import React from 'react';
import { Phone, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const ContactSection = ({ data }) => {
  return (
    <section id="contact" className="contact-section">
      <div className="section-container">
        <div className="contact-content">
          <div className="section-label">Get In Touch</div>
          <h2 className="section-heading-center">{data.title}</h2>
          <p className="contact-subtitle">{data.subtitle}</p>

          <div className="contact-info-grid">
            <div className="contact-info-card">
              <div className="contact-info-icon">
                <Phone size={28} />
              </div>
              <h3 className="contact-info-label">Phone</h3>
              {data.phone.map((number, index) => (
                <a key={index} href={`tel:${number}`} className="contact-info-value">
                  {number}
                </a>
              ))}
            </div>

            <div className="contact-info-card">
              <div className="contact-info-icon">
                <MapPin size={28} />
              </div>
              <h3 className="contact-info-label">Address</h3>
              <p className="contact-info-value">{data.address}</p>
            </div>
          </div>

          <div className="contact-cta">
            <Button 
              className="btn-primary btn-large"
              onClick={() => window.location.href = `tel:${data.phone[0]}`}
            >
              {data.ctaText}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
